import React, { Suspense, lazy, useContext, useEffect } from "react";

import { Route, Routes } from "react-router-dom";
import UserContext from "./Contexts/userContext";
import { userType } from "./Helpers/UserDetails";

const NewContinueDeal = lazy(() => import("./pages/FinanceManager/ContinueDeal/NewContinueDeal"));
const ContactUs = lazy(() => import("./pages/LandingPage/ContactUs/ContactUs"));

const AddDeal = lazy(() => import("./pages/SalesAgent/NewDeal/AddDeal"));
const FinanceManagerDashboard = lazy(() => import("./pages/FinanceManager/FinanceManagerDashboard/FinanceManagerDashboard"));
const FinanceManagerHome = lazy(() => import("./pages/FinanceManager/FinanceManagerHome/FinanceManagerHome"));
const ViewVehiclesDeal = lazy(() => import("./pages/FinanceManager/VehiclesDeal/ViewVehiclesDeal"));
const ViewApplicationFM = lazy(() => import("./pages/FinanceManager/ViewApplicationFM/ViewApplicationFM"));
const ViewCreditScore = lazy(() => import("./pages/FinanceManager/ViewCreditScore/ViewCreditScore"));
const ViewPendingFundingStatus = lazy(() => import("./pages/FinanceManager/ViewPendingFundingStatus"));
const ViewPendingBankPayments = lazy(() => import("./pages/FinanceManager/ViewReceivedFundVerfication/ViewPendingBankPayments"));
const WeOweYouOweGrid = lazy(() => import("./pages/FinanceManager/WeOwe_YouOwe/WeOweYouOweGrid"));
const GeneralManagerDashboard = lazy(() => import("./pages/GeneralManager/GeneralManagerDashboard/GeneralManagerDashboard"));
const SwapGMDashboard = lazy(() => import("./pages/GeneralManager/GeneralManagerDashboard/SwapGMDashboard"));
const GeneralManagerHome = lazy(() => import("./pages/GeneralManager/GeneralManagerHome/GeneralManagerHome"));
const FinanceCalculator = lazy(() => import("./pages/LandingPage/FinanceCalculator/FinanceCalculator"));
const Inventory = lazy(() => import("./pages/LandingPage/Inventory/Inventory"));
const LandingPage = lazy(() => import("./pages/LandingPage/LandingPage"));
const SpecificVehicle = lazy(() => import("./pages/LandingPage/SellerSide/SpecificVehicle"));
const CreditApplication = lazy(() => import("./pages/LandingPage/SellerSide/SpecificVehicle/InterestedButton/CreditApplication"));
const Services = lazy(() => import("./pages/LandingPage/Services/Services"));
const LotGuyDashboard = lazy(() => import("./pages/LotGuy/LotGuyDashboard/LotGuyDashboard"));
const LotGuyHome = lazy(() => import("./pages/LotGuy/LotGuyHome"));
const ViewDeliveryAssignments = lazy(() => import("./pages/LotGuy/ViewDeliveryAssignments/ViewDeliveryAssignments"));
const AddPictures = lazy(() => import("./pages/PictureGuy/AddPictures/AddPictures"));
const PictureGuyDashboard = lazy(() => import("./pages/PictureGuy/PictureGuyDashboard/PictureGuyDashboard"));
const PictureGuyHome = lazy(() => import("./pages/PictureGuy/PictureGuyHome/PictureGuyHome"));
const PictureGuyTable = lazy(() => import("./pages/PictureGuy/PictureGuyTable"));
const AllAppointments = lazy(() => import("./pages/SalesAgent/AllAppointments"));
const AppointmentsTabs = lazy(() => import("./pages/SalesAgent/AppointmentsTabs"));
const SalesAgentDashboard = lazy(() => import("./pages/SalesAgent/SalesAgentDashboard/SalesAgentDashboard"));
const SalesAgentHome = lazy(() => import("./pages/SalesAgent/SalesAgentHome/SalesAgentHome"));
const ViewVehicleDeal = lazy(() => import("./pages/SalesAgent/VehicleDeal/ViewVehicleDeal"));
const ViewVehicleAvailable = lazy(() => import("./pages/SalesAgent/VehicleManagment/ViewVehicleAvailable/NotSoldVehicles"));
const SalesManagerHome = lazy(() => import("./pages/SalesManager/SalesManagerHome/SalesManagerHome"));
const AddWarranties = lazy(() => import("./pages/SalesManager/Warranties/AddWarranties"));
const WarrantyTable = lazy(() => import("./pages/SalesManager/Warranties/WarrantiesTable"));
const AddParts = lazy(() => import("./pages/ServiceManager/Parts/AddParts/AddParts"));
const ViewParts = lazy(() => import("./pages/ServiceManager/Parts/ViewParts/ViewParts"));
const ViewSoldParts = lazy(() => import("./pages/ServiceManager/Parts/ViewSoldParts/ViewSoldParts"));
const ViewStock = lazy(() => import("./pages/ServiceManager/Parts/ViewStock/ViewStock"));
const AddVehiclePostInspection = lazy(
  () => import("./pages/ServiceManager/PostInspection/AddVehiclePostInspection/AddVehiclePostInspection"),
);
const ViewAllPostInspectionVehicle = lazy(
  () => import("./pages/ServiceManager/PostInspection/ViewAllPostInspectionVehicle/ViewAllPostInspectionVehicle"),
);
const AddVehiclePreInspection = lazy(() => import("./pages/ServiceManager/PreInspection/AddVehiclePreInspection/AddVehiclePreInspection"));
const ViewAllPreInspectionVehicle = lazy(
  () => import("./pages/ServiceManager/PreInspection/ViewAllPreInspectionVehicles/ViewAllPreInspectionVehicles"),
);
const Service = lazy(() => import("./pages/ServiceManager/Service/Service"));
const SwapSMDashboard = lazy(() => import("./pages/ServiceManager/ServiceManagerDashBoard/SwapSMDashboard"));
const ServiceManagerHome = lazy(() => import("./pages/ServiceManager/ServiceManagerHome/ServiceManagerHome"));
const CreateTask = lazy(() => import("./pages/ServiceManager/Services/CreateTask/CreateTask"));
const ViewTask = lazy(() => import("./pages/ServiceManager/Services/ViewTask/ViewTask"));
const SwapUserSM = lazy(() => import("./pages/ServiceManager/SwapUserSM/SwapUserSM"));
const ViewAllServiceManagerVehicles = lazy(
  () => import("./pages/ServiceManager/ViewAllServiceManagerVehicles/ViewAllServiceManagerVehicles"),
);
const TagAndTitleDashbaord = lazy(() => import("./pages/TagAndTitle/TagAndTitleDashboard/TagAndTitleDashboard"));
const TagAndTitleHome = lazy(() => import("./pages/TagAndTitle/TagAndTitleHome/TagAndTitleHome"));
const VendorDashboard = lazy(() => import("./pages/Vendor/VendorDashboard/VendorDashboard"));
const VendorHome = lazy(() => import("./pages/Vendor/VendorHome/VendorHome"));
const ViewVendorTasks = lazy(() => import("./pages/Vendor/VendorTasks/ViewVendorTasks"));
const AdminDashboard = lazy(() => import("./pages/Admin/AdminDashboard/AdminDashboard"));
const SwapAdminDashboard = lazy(() => import("./pages/Admin/AdminDashboard/SwapAdminDashboard"));
const AdminHome = lazy(() => import("./pages/Admin/AdminHome/AdminHome"));
const CreditApplicationApprovals = lazy(() => import("./pages/Admin/CreditApplicationApprovals/CreditApplicationApprovals"));
const AddDocument = lazy(() => import("./pages/Admin/Documents/AddDocument"));
const ViewDocuments = lazy(() => import("./pages/Admin/Documents/ViewDocuments"));
const ImportVehicles = lazy(() => import("./pages/Admin/ImportVehicles"));
const ViewBanks = lazy(() => import("./pages/Admin/ManageBank/ViewBanks/ViewBanks"));
const ViewPendingActivation = lazy(() => import("./pages/Admin/PendingActivation/ViewPendingActivation"));
const ProfitAndExpense = lazy(() => import("./pages/Admin/ProfitAndExpense/ProfitAndExpense"));
const RevenueDashboard = lazy(() => import("./pages/Admin/RevenueDashboard/RevenueDashboard"));
const SwapUser = lazy(() => import("./pages/Admin/SwapUser/SwapUser"));
const ViewAllAdminDeals = lazy(() => import("./pages/Admin/ViewAllAdminDeals/ViewAllAdminDeals"));
const ViewAdminVehicle = lazy(() => import("./pages/Admin/ViewAllAdminVehicles/ViewAdminVehicle"));
const ViewAllAdminVehicles = lazy(() => import("./pages/Admin/ViewAllAdminVehicles/ViewAllAdminVehicles"));
const ViewInventoryVehicles = lazy(() => import("./pages/Admin/ViewAllAdminVehicles/ViewInventoryVehicles"));
const ViewAllAlerts = lazy(() => import("./pages/Admin/ViewAllAlerts/ViewAllAlerts"));
const ViewAllExpenses = lazy(() => import("./pages/Admin/ViewAllExpenses/ViewAllExpenses"));
const ViewAllUsers = lazy(() => import("./pages/Admin/ViewAllUsers/ViewAllUsers"));
const ViewAllRevenue = lazy(() => import("./pages/Admin/ViewRevenue/ViewAllRevenue"));
const YouOweWeOweApproval = lazy(() => import("./pages/Admin/YouOweWeOweApproval/YouOweWeOweApproval"));
const BdcDashboard = lazy(() => import("./pages/BdcPortal/BdcDashboard/BdcDashboard"));
const BdcHome = lazy(() => import("./pages/BdcPortal/BdcHome/BdcHome"));
const BookAppointment = lazy(() => import("./pages/BdcPortal/BookAppointment/BookAppointment"));
const Leads = lazy(() => import("./pages/BdcPortal/Leads"));
const AddLead = lazy(() => import("./pages/BdcPortal/Leads/AddLead"));
const EditProfile = lazy(() => import("./components/GeneralComponents/EditProfle/EditProfile"));
const NewPassword = lazy(() => import("./components/GeneralComponents/SignIn/NewPassword"));
const SignIn = lazy(() => import("./components/GeneralComponents/SignIn/SignIn"));
const SignUp = lazy(() => import("./components/GeneralComponents/SignUp/SignUp"));
const Layout = lazy(() => import("./components/Layout"));
const AddDealership = lazy(() => import("./components/SuperAdminComponents/Dealership/AddDealership"));
const ViewDealerships = lazy(() => import("./components/SuperAdminComponents/Dealership/ViewDealerships"));
const ManageTagAndTitles = lazy(() => import("./components/TagAndTitleComponents/ManageTagsAndTitles/ManageTagsAndTitles"));
const ViewPendingTagsAndTitles = lazy(() => import("./components/TagAndTitleComponents/ViewPendingTagsAndTitles/ViewPendingTagsAndTitles"));
const AddExpense = lazy(() => import("./pages/Admin/AddExpense/AddExpense"));
const AddRevenue = lazy(() => import("./pages/Admin/AddRevenue/AddRevenue"));
const AddUser = lazy(() => import("./pages/Admin/AddUser/AddUser"));

const CreateChat = lazy(() => import("./components/Chats/CreateChat"));
const RequireAuth = lazy(() => import("./React_JWT_Auth/RequireAuth"));

import CustomAnimation from "./components/GeneralComponents/CustomLoader/CustomAnimation";
import ViewInventoryVehicleModalProvider from "./pages/Admin/ViewAllAdminVehicles/ViewSpecificVehicleView/ViewInventoryVehicleModalProvider";
import DeskADeal from "./pages/SalesAgent/DeskADeal/DeskADeal";
import dealershipInfo from "./Helpers/currentDealership.jsx/dealershipInfo";
import { dealershipID } from "./Helpers/Constants";
import { Helmet, HelmetProvider } from "react-helmet-async";
const CreditPulls = lazy(() => import("./pages/Admin/CreditPulls"));
const AddLender = lazy(() => import("./pages/Admin/ManageBank/AddLender"));
const WebsiteManagement = lazy(() => import("./pages/Admin/WebsiteManagement"));
const ViewAppointments = lazy(() => import("./pages/BdcPortal/ViewAppointments/ViewAppointments"));
const ViewVehiclesAvailable = lazy(() => import("./pages/BdcPortal/ViewVehiclesAvailable/ViewVehiclesAvailable"));
const AddAuction = lazy(() => import("./pages/Dispatcher/AddAuction/AddAuction"));
const AddTransportAssignment = lazy(() => import("./pages/Dispatcher/AddTransportAssignment/AddTransportAssignment"));
const AddTransporter = lazy(() => import("./pages/Dispatcher/AddTransporter/AddTransporter"));
const AddVehicle = lazy(() => import("./pages/Dispatcher/AddVehicle/AddVehicle"));
const AddVehicleFloor = lazy(() => import("./pages/Dispatcher/AddVehicleFloor/AddVehicleFloor"));
const DispatcherDashboard = lazy(() => import("./pages/Dispatcher/DispatcherDashboard/DispatcherDashboard"));
const DispatcherHome = lazy(() => import("./pages/Dispatcher/DispatcherHome/DispatcherHome"));
const ReturnedToAuctionVehicle = lazy(() => import("./pages/Dispatcher/ReturnedToAuctionVehicle"));
const AllVehicleTranportation = lazy(() => import("./pages/Dispatcher/VehicleTransportation/AllVehicleTransportation"));
const ViewAllAuction = lazy(() => import("./pages/Dispatcher/ViewAllAcution/ViewAllAuction"));
const ViewAllTransporter = lazy(() => import("./pages/Dispatcher/ViewAllTransporter/ViewAllTransporter"));
const ViewFloorVehicles = lazy(() => import("./pages/Dispatcher/ViewFloorVehicles/ViewFloorVehicles"));
const ViewVehicles = lazy(() => import("./pages/Dispatcher/ViewVehicles"));

const dealership = dealershipInfo[dealershipID];
const svgBlob = new Blob([dealership.logo], { type: "image/svg+xml" });

const logo = URL?.createObjectURL(svgBlob);
const App = () => {
  const { isAdmin, isGeneralManager, isSalesManager, isServiceManager, isLotGuy, swapUser } = useContext(UserContext);
  return (
    <HelmetProvider>
      <Suspense fallback={<CustomAnimation visible={true} />}>
        <Helmet>
          <title>{dealership.name}</title>
          <link rel="icon" type="image/svg+xml" href={logo} sizes={dealership.favIconSize} />
        </Helmet>

        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/creditapplication" element={<CreditApplication />} />
            <Route path="/creditapplication/:id" element={<CreditApplication />} />
            <Route path="/" element={<LandingPage />} />
            <Route path="/becomeapartner" element={<Services />} />
            <Route path="/contactUs" element={<ContactUs />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/financeCalculator" element={<FinanceCalculator />} />
            <Route path="/inventory/:id" element={<SpecificVehicle />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/signIn" element={<SignIn />} />

            <Route path="/forgot-password/:token" element={<NewPassword />} />
            <Route element={<RequireAuth allowedRole={["Auction Manager", "Admin", "General Manager"]} />}>
              <Route
                path={isAdmin ? "/admin" : isGeneralManager ? "/generalmanager" : "/auctionmanager"}
                element={isAdmin ? <AdminHome /> : isGeneralManager ? <GeneralManagerHome /> : <DispatcherHome />}
              >
                <Route
                  index
                  element={isAdmin ? <SwapAdminDashboard /> : isGeneralManager ? <SwapGMDashboard /> : <DispatcherDashboard />}
                />
                <Route path="addVehicleFloor" element={<AddVehicleFloor />} />
                <Route path="updateFloor/:businessType/:editId" element={<AddVehicleFloor />} />
                <Route path="viewVehicleFloors" element={<ViewFloorVehicles />} />
                {/* Auction Company */}

                <Route path="addAuction" element={<AddAuction />} />
                <Route path="viewAuction" element={<ViewAllAuction />} />
                <Route path="updateAuction/:businessType/:editId" element={<AddAuction />} />
                <Route
                  path="viewInventoryVehicles"
                  element={
                    <ViewInventoryVehicleModalProvider>
                      <ViewInventoryVehicles />
                    </ViewInventoryVehicleModalProvider>
                  }
                />
                <Route path="addVehicle" element={<AddVehicle />} />
                <Route path="editVehicle/:editId" element={<AddVehicle />} />
                <Route path="addTransporter" element={<AddTransporter />} />
                <Route path="updateTransporter/:businessType/:editId" element={<AddTransporter />} />
                <Route path="viewAllTransporters" element={<ViewAllTransporter />} />
                <Route path="viewVehicles" element={<ViewVehicles />} />
                <Route path="addTransportAssignment" element={<AddTransportAssignment />} />
                <Route path="addTransportAssignment/:vehicleId" element={<AddTransportAssignment />} />
                <Route path="editTransportAssignment/:editId" element={<AddTransportAssignment />} />
                <Route path="viewVehiclesInTransit" element={<AllVehicleTranportation dispatchStatus="In Transit" />} />
                <Route path="viewVehiclesReceived" element={<AllVehicleTranportation dispatchStatus="Received" />} />
                <Route path="viewVehiclesReturned" element={<ReturnedToAuctionVehicle />} />
                <Route path="settings" element={<EditProfile />} />
                <Route path="import-vehicles" element={<ImportVehicles />} />
                <Route path="credit-pulls" element={<CreditPulls />} />
                {/* </Route> */}
              </Route>
            </Route>
            <Route element={<RequireAuth allowedRole={["Service Manager", "Admin", "Lot Guy", "General Manager"]} />}>
              {/* Lot Guy Routes */}
              <Route
                path={isAdmin ? "/admin" : isGeneralManager ? "/generalmanager" : isServiceManager ? "/servicemanager" : "/lotguy"}
                element={
                  isAdmin ? (
                    <AdminHome />
                  ) : isGeneralManager ? (
                    <GeneralManagerHome />
                  ) : isServiceManager ? (
                    <ServiceManagerHome />
                  ) : (
                    <LotGuyHome />
                  )
                }
              >
                <Route
                  index
                  element={
                    isAdmin ? (
                      <AdminDashboard />
                    ) : isGeneralManager ? (
                      <GeneralManagerDashboard />
                    ) : isServiceManager ? (
                      <SwapSMDashboard />
                    ) : (
                      <LotGuyDashboard />
                    )
                  }
                />
                <Route
                  path="viewInventoryVehicles"
                  element={
                    <ViewInventoryVehicleModalProvider>
                      <ViewInventoryVehicles />
                    </ViewInventoryVehicleModalProvider>
                  }
                />
                <Route path="service" element={<Service />} />
                <Route path="service/:tabValue" element={<Service />} />
                <Route path="serviceVehicles" element={<ViewAllServiceManagerVehicles />} />

                <Route path="viewVehiclesInTransit" element={<AllVehicleTranportation dispatchStatus="In Transit" />} />
                <Route path="viewVehiclesReceived" element={<AllVehicleTranportation dispatchStatus="Received" />} />

                <Route path="addVehicleToPreInspection" element={<AddVehiclePreInspection />} />
                <Route path="addVehicleToPreInspection/:vehicleId" element={<AddVehiclePreInspection />} />
                <Route path="preInspection/:editId" element={<AddVehiclePreInspection />} />

                <Route path="viewAllPreInspectionVehicles" element={<ViewAllPreInspectionVehicle />} />
                <Route path="createtask" element={<CreateTask />} />
                <Route path="createtask/:vehicle/:vehicleId" element={<CreateTask />} />
                <Route path="createtask/rights/:rights/:editId" element={<CreateTask />} />
                <Route path={"viewAssignedTasks"} element={isLotGuy || swapUser ? <ViewVendorTasks /> : <ViewTask />} />
                <Route path={"viewTasks"} element={<ViewTask />} />
                {/* this for testing purpose to check whether the data is correct or not */}

                <Route path="viewAssignedTasks" element={<ViewVendorTasks />} />
                <Route path="deliveryAssignments" element={<ViewDeliveryAssignments />} />

                {/* this for testing purpose to check whether the data is correct or not */}
                <Route path="addVehicleToPostInspection" element={<AddVehiclePostInspection />} />
                <Route path="addVehicleToPostInspection/:vehicleId" element={<AddVehiclePostInspection />} />
                <Route path="Postinspection/:editId" element={<AddVehiclePostInspection />} />
                <Route path="deliveryAssignments" element={<ViewDeliveryAssignments />} />
                <Route path="viewAllPostInspectionCompleted" element={<ViewAllPostInspectionVehicle />} />

                <Route path="viewPictureGuyVehicle" element={<PictureGuyTable />} />
                <Route path="warranty" element={<AddWarranties />} />
                <Route path="warranty/:editId" element={<AddWarranties />} />
                <Route path="warranties" element={<WarrantyTable />} />
                <Route path="addParts" element={<AddParts />} />
                <Route path="editPart/:editId" element={<AddParts />} />
                <Route path="viewParts" element={<ViewParts />} />
                <Route path="viewStock" element={<ViewStock />} />
                <Route path="viewSoldParts" element={<ViewSoldParts />} />
                <Route path="settings" element={<EditProfile />} />
                <Route path="swapUserSM" element={<SwapUserSM />} />
              </Route>
            </Route>

            <Route element={<RequireAuth allowedRole={["Service Vendor", "Admin", "General Manager"]} />}>
              <Route
                path={isAdmin ? "/admin" : isGeneralManager ? "/generalmanager" : "/servicevendor"}
                element={isAdmin ? <AdminHome /> : isGeneralManager ? <GeneralManagerHome /> : <VendorHome />}
              >
                <Route
                  index
                  element={isAdmin ? <AdminDashboard /> : isGeneralManager ? <GeneralManagerDashboard /> : <VendorDashboard />}
                />
                {/* <Route path="vendorService" element={<VendorService />} /> */}
                <Route
                  path="viewInventoryVehicles"
                  element={
                    <ViewInventoryVehicleModalProvider>
                      <ViewInventoryVehicles />
                    </ViewInventoryVehicleModalProvider>
                  }
                />
                <Route path="settings" element={<EditProfile />} />
                <Route path="createtask/rights/:rights/:editId" element={<CreateTask />} />
                <Route path="viewAssignedTasks" element={<ViewVendorTasks />} />

                <Route path="deliveryAssignments" element={<ViewDeliveryAssignments />} />
              </Route>
            </Route>

            {/* Picture Guy */}
            <Route element={<RequireAuth allowedRole={["Picture Guy", "Admin", "General Manager"]} />}>
              <Route
                path={isAdmin ? "/admin" : isGeneralManager ? "/generalmanager" : "/pictureguy"}
                element={isAdmin ? <AdminHome /> : isGeneralManager ? <GeneralManagerHome /> : <PictureGuyHome />}
              >
                <Route
                  index
                  element={isAdmin ? <AdminDashboard /> : isGeneralManager ? <GeneralManagerDashboard /> : <PictureGuyDashboard />}
                />
                <Route
                  path="viewInventoryVehicles"
                  element={
                    <ViewInventoryVehicleModalProvider>
                      <ViewInventoryVehicles />
                    </ViewInventoryVehicleModalProvider>
                  }
                />
                <Route path="settings" element={<EditProfile />} />
                <Route path="addPictures" element={<AddPictures />} />
                <Route path="addPictures/:vehicleId" element={<AddPictures />} />
                <Route path="viewVehiclePending" element={<PictureGuyTable />} />
              </Route>
            </Route>
            <Route element={<RequireAuth allowedRole={["BDC", "Admin", "General Manager"]} />}>
              <Route
                path={isAdmin ? "/admin" : isGeneralManager ? "/generalmanager" : "/bdc"}
                element={isAdmin ? <AdminHome /> : isGeneralManager ? <GeneralManagerHome /> : <BdcHome />}
              >
                <Route index element={isAdmin ? <AdminDashboard /> : isGeneralManager ? <GeneralManagerDashboard /> : <BdcDashboard />} />

                <Route path="viewVehiclesAvailable" element={<ViewVehiclesAvailable title="View All Vehicles" />} />
                <Route
                  path="viewInventoryVehicles"
                  element={
                    <ViewInventoryVehicleModalProvider>
                      <ViewInventoryVehicles />
                    </ViewInventoryVehicleModalProvider>
                  }
                />
                <Route path="bookAppointment" element={<BookAppointment />} />
                <Route path="bookAppointment/:vehicleId" element={<BookAppointment />} />
                <Route path="bookAppointment/:vehicleId/:customerId" element={<BookAppointment />} />
                <Route path="editAppointment/:editId" element={<BookAppointment />} />
                {/* Leads Route in bdc */}
                <Route path="addLeads" element={<AddLead />} />
                <Route
                  path="leads"
                  element={
                    <ViewInventoryVehicleModalProvider key="leads">
                      <Leads />
                    </ViewInventoryVehicleModalProvider>
                  }
                />
                <Route path="viewAppointments" element={<ViewAppointments />} />

                <Route path="settings" element={<EditProfile />} />
              </Route>
            </Route>
            <Route element={<RequireAuth allowedRole={["Sales Person", "Sales Agent", "Admin", "Sales Manager", "General Manager"]} />}>
              <Route
                path={isAdmin ? "/admin" : isGeneralManager ? "/generalmanager" : isSalesManager ? "/salesmanager" : "/salesperson"}
                element={
                  isAdmin ? (
                    <AdminHome />
                  ) : isGeneralManager ? (
                    <GeneralManagerHome />
                  ) : isSalesManager ? (
                    <SalesManagerHome />
                  ) : (
                    <SalesAgentHome />
                  )
                }
              >
                <Route
                  index
                  element={isAdmin ? <AdminDashboard /> : isGeneralManager ? <GeneralManagerDashboard /> : <SalesAgentDashboard />}
                />
                <Route path="credit-pulls" element={<CreditPulls />} />
                <Route
                  path="viewInventoryVehicles"
                  element={
                    <ViewInventoryVehicleModalProvider>
                      <ViewInventoryVehicles />
                    </ViewInventoryVehicleModalProvider>
                  }
                />
                {/* Appointment Managment*/}
                <Route path="bookAppointment" element={<BookAppointment />} />
                <Route path="addLeads" element={<AddLead />} />
                <Route path="bookAppointment/:vehicleId" element={<BookAppointment />} />
                <Route path="bookAppointment/:vehicleId/:customerId" element={<BookAppointment />} />
                <Route path="editAppointment/:editId" element={<BookAppointment />} />
                <Route
                  path="allAppointments"
                  element={
                    <AppointmentsTabs
                      hasButton={true}
                      edit={userType() === "Sales Person" ? false : true}
                      defaultTab={isAdmin || isGeneralManager ? "All" : "My"}
                    />
                  }
                />
                <Route
                  path="allAppointments/:type"
                  element={<AppointmentsTabs hasButton={true} edit={userType() === "Sales Person" ? false : true} />}
                />
                <Route path="myAppointments" element={<AllAppointments hasButton={true} myAppointments={true} />} />
                {/* Vehicle Managment*/}
                <Route path="viewVehicleDeal" element={<ViewVehicleDeal />} />
                <Route path="view-deals" element={<ViewVehicleDeal />} />
                <Route path="deal/vehicle/:vehicleId" element={<AddDeal />} />
                <Route path="deal/vehicle/:vehicleId/customer/:customerEmail/step1" element={<AddDeal />} />
                <Route path="editAppointment/edit/:editId" element={<BookAppointment />} />
                <Route path="addDeal/:dealId" element={<AddDeal />} />
                <Route path="deal/:dealId" element={<AddDeal />} />
                <Route path="readyToSellVehicles" element={<ViewVehicleAvailable />} />
                <Route
                  path="leads"
                  element={
                    <ViewInventoryVehicleModalProvider key="leads">
                      <Leads />
                    </ViewInventoryVehicleModalProvider>
                  }
                />

                <Route path="settings" element={<EditProfile />} />
                <Route path="desk-a-deal" element={<DeskADeal />} />

                {/* Receive Vehicle */}
                <Route path="viewVehiclesInTransit" element={<AllVehicleTranportation dispatchStatus="In Transit" />} />
              </Route>
            </Route>

            <Route element={<RequireAuth allowedRole={["Finance Manager", "Admin", "General Manager"]} />}>
              <Route
                path={isAdmin ? "/admin" : isGeneralManager ? "/generalmanager" : "/financeManager"}
                element={isAdmin ? <AdminHome /> : isGeneralManager ? <GeneralManagerHome /> : <FinanceManagerHome />}
              >
                <Route
                  index
                  element={isAdmin ? <AdminDashboard /> : isGeneralManager ? <GeneralManagerDashboard /> : <FinanceManagerDashboard />}
                />
                <Route
                  path="viewInventoryVehicles"
                  element={
                    <ViewInventoryVehicleModalProvider>
                      <ViewInventoryVehicles />
                    </ViewInventoryVehicleModalProvider>
                  }
                />
                <Route path="continueDeal/:dealId" element={<NewContinueDeal />} />

                <Route path="viewApplications" element={<ViewApplicationFM />} />

                <Route path="viewVehiclesDeal" element={<ViewVehiclesDeal />} />
                <Route path="viewFundingStatusDeal" element={<ViewPendingFundingStatus />} />
                <Route path="viewPendingBankPayments" element={<ViewPendingBankPayments />} />
                <Route path="viewCreditScore" element={<ViewCreditScore />} />
                <Route path="credit-pulls" element={<CreditPulls />} />
                <Route path="viewYouOweWeOwe" element={<WeOweYouOweGrid />} />
                <Route path="settings" element={<EditProfile />} />
                <Route path="CreditApplicationApprovals" element={<CreditApplicationApprovals />} />

                {/* additional routes acquired from sales  */}
                <Route
                  path="leads"
                  element={
                    <ViewInventoryVehicleModalProvider key="leads">
                      <Leads />
                    </ViewInventoryVehicleModalProvider>
                  }
                />
                <Route path="addLeads" element={<AddLead />} />
                <Route path="addDeal/:dealId" element={<AddDeal />} />
                <Route path="deal/:dealId" element={<AddDeal />} />
                <Route path="deal/vehicle/:vehicleId" element={<AddDeal />} />
                <Route path="deal/vehicle/:vehicleId/customer/:customerEmail/step1" element={<AddDeal />} />
                <Route path="desk-a-deal" element={<DeskADeal />} />

                <Route path="viewVehiclesInTransit" element={<AllVehicleTranportation dispatchStatus="In Transit" />} />

                <Route path="bookAppointment" element={<BookAppointment />} />
                <Route path="bookAppointment/:vehicleId" element={<BookAppointment />} />
                <Route path="bookAppointment/:vehicleId/:customerId" element={<BookAppointment />} />
                <Route path="editAppointment/:editId" element={<BookAppointment />} />
              </Route>
            </Route>
            {/* Tags And Title */}
            <Route element={<RequireAuth allowedRole={["Tag And Title Guy", "Admin", "General Manager"]} />}>
              <Route
                path={isAdmin ? "/admin" : isGeneralManager ? "/generalmanager" : "/tagAndTitleguy"}
                element={isAdmin ? <AdminHome /> : isGeneralManager ? <GeneralManagerHome /> : <TagAndTitleHome />}
              >
                <Route
                  index
                  element={isAdmin ? <AdminDashboard /> : isGeneralManager ? <GeneralManagerDashboard /> : <TagAndTitleDashbaord />}
                />
                <Route
                  path="viewInventoryVehicles"
                  element={
                    <ViewInventoryVehicleModalProvider>
                      <ViewInventoryVehicles />
                    </ViewInventoryVehicleModalProvider>
                  }
                />
                <Route path="editTagsAndTitles/:editId" element={<ManageTagAndTitles />} />
                <Route path="pendingTagsAndTitles" element={<ViewPendingTagsAndTitles />} />
                <Route path="settings" element={<EditProfile />} />
              </Route>
            </Route>
            {/* Admin */}
            <Route element={<RequireAuth allowedRole={["Admin"]} />}>
              <Route path="/admin" element={<AdminHome />}>
                {/* <Route index element={<AdminDashboard />} /> */}
                <Route index element={<SwapAdminDashboard />} />

                <Route path="revenueDashboard" element={<RevenueDashboard />} />
                <Route path="alerts" element={<ViewAllAlerts />} />
                <Route path="viewAllUsers" element={<ViewAllUsers />} />
                {/*Dealership Routes */}
                <Route path="addDealership" element={<AddDealership />} />
                <Route path="editDealership/:editId" element={<AddDealership />} />
                <Route path="viewAllDealerships" element={<ViewDealerships />} />

                <Route path="viewAdminVehicles" element={<ViewAllAdminVehicles />} />
                <Route
                  path="viewInventoryVehicles"
                  element={
                    <ViewInventoryVehicleModalProvider>
                      <ViewInventoryVehicles />
                    </ViewInventoryVehicleModalProvider>
                  }
                />
                <Route path="viewAllAdminVehicles" element={<ViewAdminVehicle />} />
                <Route path="CreditApplicationApprovals" element={<CreditApplicationApprovals />} />
                <Route path="youOweWeOweApproval" element={<YouOweWeOweApproval />} />
                <Route path="viewAllDeals" element={<ViewAllAdminDeals />} />
                <Route path="addUser" element={<AddUser />} />
                <Route path="editUser/:editId" element={<AddUser />} />
                <Route path="pendingActivation" element={<ViewPendingActivation />} />
                <Route path="addBank" element={<AddLender />} />
                <Route path="updateBank/:businessType/:editId" element={<AddLender />} />

                <Route path="viewAllBanks" element={<ViewBanks />} />
                <Route path="profitAndExpenseValues" element={<ProfitAndExpense />} />
                <Route
                  path="leads"
                  element={
                    <ViewInventoryVehicleModalProvider key="leads">
                      <Leads />
                    </ViewInventoryVehicleModalProvider>
                  }
                />

                {/*Expennse Routes */}
                <Route path="addExpense" element={<AddExpense />} />
                <Route path="editExpense/:editId" element={<AddExpense />} />
                <Route path="viewAllExpenses" element={<ViewAllExpenses />} />
                {/*Revenue Routes */}
                <Route path="addRevenue" element={<AddRevenue />} />
                <Route path="editRevenue/:editId" element={<AddRevenue />} />
                <Route path="viewAllRevenue" element={<ViewAllRevenue />} />
                {/* Website Management */}
                <Route path="websitemanagement" element={<WebsiteManagement />} />
                {/*Parts Routes */}
                <Route path="addParts" element={<AddParts />} />
                <Route path="editPart/:editId" element={<AddParts />} />
                <Route path="viewParts" element={<ViewParts />} />
                <Route path="viewStock" element={<ViewStock />} />
                <Route path="viewSoldParts" element={<ViewSoldParts />} />
                <Route path="addDocument" element={<AddDocument />} />
                <Route path="editDocument/:editId" element={<AddDocument />} />
                <Route path="viewDocuments" element={<ViewDocuments />} />
                <Route path="chat" element={<CreateChat />} />
                <Route path="settings" element={<EditProfile />} />
                <Route path="swapUser" element={<SwapUser />} />
              </Route>
            </Route>
            <Route element={<RequireAuth allowedRole={["General Manager"]} />}>
              <Route path="/generalmanager" element={<GeneralManagerHome />}>
                <Route index element={<SwapGMDashboard />} />
                <Route path="viewAllUsers" element={<ViewAllUsers />} />
                <Route path="alerts" element={<ViewAllAlerts />} />
                <Route path="CreditApplicationApprovals" element={<CreditApplicationApprovals />} />
                <Route path="youOweWeOweApproval" element={<YouOweWeOweApproval />} />
                <Route path="websitemanagement" element={<WebsiteManagement />} />
                <Route path="pendingActivation" element={<ViewPendingActivation />} />

                <Route path="viewAllAdminVehicles" element={<ViewAllAdminVehicles />} />
                <Route path="viewAllDeals" element={<ViewAllAdminDeals />} />
                {/*Parts Routes */}
                <Route path="addParts" element={<AddParts />} />
                <Route path="editPart/:editId" element={<AddParts />} />
                <Route path="viewParts" element={<ViewParts />} />
                <Route path="viewStock" element={<ViewStock />} />
                <Route path="viewSoldParts" element={<ViewSoldParts />} />
                <Route path="addUser" element={<AddUser />} />
                <Route path="editUser/:editId" element={<AddUser />} />
                <Route path="addBank" element={<AddLender />} />
                <Route path="updateBank/:businessType/:editId" element={<AddLender />} />
                <Route path="viewAllBanks" element={<ViewBanks />} />
                <Route
                  path="leads"
                  element={
                    <ViewInventoryVehicleModalProvider key="leads">
                      <Leads />
                    </ViewInventoryVehicleModalProvider>
                  }
                />
                <Route path="chat" element={<CreateChat />} />
                <Route path="settings" element={<EditProfile />} />
                <Route path="swapUser" element={<SwapUser />} />
              </Route>
              <Route path="/*" element={<RequireAuth allowedRole={[]} />} />
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </HelmetProvider>
  );
};

export default App;
